module.exports = __webpack_public_path__ + "static/media/6.c62965b0.jpg";